// Utility function to handle asset paths with the correct base path

// Define the base path from the Next.js config
export const basePath = '/df';

/**
 * Get the full path for static assets with the basePath included
 * @param {string} assetPath - The path to the static asset (should start with a slash)
 * @returns {string} The full path including basePath
 */
export function getAssetPath(assetPath: string): string {
  // Ensure the assetPath starts with a slash
  const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
  return `${basePath}${normalizedPath}`;
}

/**
 * Get the full path for API endpoints with the basePath included
 * @param {string} apiPath - The path to the API endpoint (should start with a slash)
 * @returns {string} The full path including basePath
 */
export function getApiPath(apiPath: string): string {
  // Ensure the apiPath starts with a slash
  const normalizedPath = apiPath.startsWith('/') ? apiPath : `/${apiPath}`;
  return `${basePath}${normalizedPath}`;
} 